export default __webpack_public_path__ + "static/media/Foto-04.d155921b.png";